import React, { Component, Fragment } from 'react';
import Player from '../Player';
import styles from './Spotpoint.module.css';
import Checkbox from 'rc-checkbox';
import Button from '../Button';

export default class Spotpoint extends Component {
  state = {
    enabled: false,
    loading: true,
  };

  toggleEnabled = () => {
    const { enabled } = this.state;
    this.setState({ enabled: !enabled });
  };

  updateMaterial = async () => {
    const spotX = document.getElementById('spotX').innerText;
    const spotY = document.getElementById('spotY').innerText;
    if (spotX && spotY) {
      const { saveMaterial } = this.props;
      await saveMaterial(spotX, spotY);
    }
  };

  setLoading = loading => {
    this.setState({ loading });
  };

  render() {
    const { enabled, loading } = this.state;
    const { initSpotPoint, file, message, importFile } = this.props;
    return (
      <div className={styles.container}>
        <div className={styles.addSpot}>
          <Checkbox checked={enabled} onChange={this.toggleEnabled} />
          <div class={styles.addSpotTxt}> Add spot point </div>
        </div>
        {enabled && (
          <Fragment>
            <div className={styles.title}> Set Spot Point</div>
            <div style={{ display: 'flex' }}>
              <div className={styles.description}>
                {' '}
                Please click the spot point on the image below.{' '}
              </div>
              <div className={styles.spot}> x: </div>{' '}
              <div className={styles.description} id="spotX" />
              <div className={styles.spot}> y: </div>{' '}
              <div className={styles.description} id="spotY" />
              <Button
                style={{ marginLeft: 20 }}
                height="32px"
                text="Save"
                onClick={this.updateMaterial}
              />
              {message && <div className={styles.message}>{message} </div>}
              {loading && (
                <img className={styles.loading} src="/img/loading.svg" />
              )}
            </div>
            <Player
              initializePlayer={initSpotPoint}
              importFile={importFile}
              type="spotpoint"
              file={file}
              setLoading={this.setLoading}
            />
          </Fragment>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Spotpoint/index.js